import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root',
})
export class DataDeletionMapper {
    public addDeletionProperty(data: object[]): object[] {
        const receivedData: object[] = cloneDeep(data);

        for (const element of receivedData) {
            element['deletion'] = false;
        }

        return receivedData;
    }

    public deleteDeletionProperty(data: object[]): object[] {
        const receivedData: object[] = cloneDeep(data);

        for (const element of receivedData) {
            delete element['deletion'];
        }

        return receivedData;
    }
}
